/**
 * @generated SignedSource<<afa666ed833d77171278f3d3257b09da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteCustomFieldDropdownOptionConfirmationModalQuery$variables = {
  customFieldId?: string | null;
  hasCustomFieldId: boolean;
};
export type DeleteCustomFieldDropdownOptionConfirmationModalQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeleteCustomFieldDropdownOptionConfirmationModal_viewer">;
  } | null;
};
export type DeleteCustomFieldDropdownOptionConfirmationModalQuery = {
  variables: DeleteCustomFieldDropdownOptionConfirmationModalQuery$variables;
  response: DeleteCustomFieldDropdownOptionConfirmationModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasCustomFieldId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "custom_field_dropdown_options_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"custom_field_dropdown_options_modal\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "customFieldId",
                    "variableName": "customFieldId"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "customFieldId"
                  }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "customFieldDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDropdownOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUsed",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "DropdownCustomField",
                    "abstractKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc323775530f3302e47a7dd9bb5f3544",
    "id": null,
    "metadata": {},
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "operationKind": "query",
    "text": "query DeleteCustomFieldDropdownOptionConfirmationModalQuery(\n  $customFieldId: ID\n  $hasCustomFieldId: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"custom_field_dropdown_options_modal\")\n    ...DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl @include(if: $hasCustomFieldId)\n    id\n  }\n}\n\nfragment DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl on Viewer {\n  customFieldDefinition(id: $customFieldId) {\n    __typename\n    ... on DropdownCustomField {\n      options {\n        id\n        displayName\n        isUsed\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c641b863e2cde6d16b49387990bae22f";

export default node;
